<template>
  <div id="ticket-setting">
    <div class="setting-card-hidden ticket">
      <div class="px-1 setting-card-scroll">
        <h4  class="mb-6 text-2xl font-bold">Ticket Setting</h4>
        <div class="flex align-center">
          <div class="flex w-full">
            <div class="w-7/12 pr-5">
              <h4 class="text-lg font-bold text-title mt-3 mb-6 pb-2">Ticket Template</h4>
              <vx-card class="w-11/12 my-4 shadow-md" v-for="(ticket, index) in ticketList.items" :key="index">
                  <div class="flex justify-between align-center">
                      <div class="break-word" v-if="ticket.subject != 'custom_text'">{{index + 1}}. {{ticket.name}}</div>
                      <div class="break-word cursor-pointer" v-else>{{index + 1}}. <u @click="updateTicket(ticket)">{{ticket.content}}</u></div>
                      <div class="flex align-center" style="min-width: 100px;">
                          <feather-icon icon="ArrowUpIcon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="upTicket(ticket)"/>
                          <feather-icon icon="ArrowDownIcon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="downTicket(ticket)"/>
                          <!-- <feather-icon icon="Trash2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="deleteTicket(ticket)"/> -->
                          <!-- <vs-button @click.stop="deleteTicket(ticket)" type="filled" size="small" icon-pack="feather" icon="icon-trash" color="orange" class="ml-4" style="min-width: 28px;"></vs-button> -->
                          <img src="../../assets/images/trash-icon.png" class="ml-5 cursor-pointer trash-icon" @click.stop="deleteTicket(ticket)" />
                      </div>
                  </div>
              </vx-card>

              <vx-card class="w-11/12 my-4 shadow-md plus-card cursor-pointer" @click="popupAddActive = true">
                <div class="flex justify-center align-center">
                  <feather-icon icon="PlusIcon" svgClasses="w-8 stroke-current ml-4 icon-plus"/>
                </div>
              </vx-card>
              <vs-popup class="holamundo create-block-ticket-popup" title="Create new block" :active.sync="popupAddActive">
                <div>
                  <div>
                    <label>Block Name</label>
                    <v-select class="mb-4" v-model="select" label="name" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false"/>
                    <label>Param (Optional)</label>
                    <vs-input v-model="content" class="w-full"/>
                  </div>
                  <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                      <vs-button class="mr-6 align-center save-responsive" @click="addTicket">Save</vs-button>
                      <vs-button class="cancel-responsive" type="border" color="danger" @click="popupAddActive=false">Cancel</vs-button>
                  </div>
                </div>
              </vs-popup>
            </div>
            <div class="w-5/12">
              <div class="flex align-center justify-between">
                <h4 class="text-lg font-bold text-title">Ticket Preview</h4>
                <vs-button class="px-4" @click="popupSetDefault = true">Restore default</vs-button>
              </div>
              <vx-card class="w-full my-4 shadow-md">
              <!-- <div v-for="(ticket, index) in ticketList.items" :key="index">
                <b v-if="ticket.subject == 'business_name'">Go Checkin</b>
                <span v-if="ticket.subject == 'name'" >Customer: ...........................</span>
                <span v-if="ticket.subject == 'checkin'">Checkin: 01/01/2018 12:00 pm</span>
                <span v-if="ticket.subject == 'point'">Current point: ...........................</span>
                <span v-if="ticket.subject == 'visit'">Visit: ...........................</span>
                <span v-if="ticket.subject == 'selected_service'">* Service 1<br>* Service 2<br>* Service 3</span>
                <span v-if="ticket.subject == 'staff'">STAFF 1 &nbsp;&nbsp;&nbsp;&nbsp;STAFF 2<br>_________&nbsp;&nbsp;&nbsp;&nbsp;_________</span>
                <span v-if="ticket.subject == 'list_service'">+ Service Category<br>[ ] [ ] Service 1<br>[ ] [ ] Service 2<br>[ ] [ ] Service 3</span>
                <span v-if="ticket.subject == 'tip'">TIP:<br>STAFF 1: _______________<br>STAFF 2: _______________</span>
                <span v-if="ticket.subject == 'order_id'">Check-in ID: #......</span>
                <span v-if="ticket.subject == 'custom_text'">{{ticket.content}}</span>
                <span v-if="ticket.subject == 'new_line'"><br></span>
                <span v-if="ticket.subject == 'phone'">Phone: (xxx) xxx - 1234</span>
                <span v-if="ticket.subject == 'cut'"><br></span>
              </div> -->
                <div v-html="ticketList.template_text"></div>
              </vx-card>
            </div>
          </div>
          <vs-popup class="holamundo update-ticket-popup" title="Update ticket template" :active.sync="popupUpdateActive">
            <div>
              <div>
                <label>Block Name</label>
                <v-select class="mb-4" v-model="selected" label="name" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false" :key="key_selected"/>
                <label>Param (Optional)</label>
                <vs-input v-model="param" class="w-full"/>
              </div>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center save-responsive" @click="submitUpdate">Save</vs-button>
                  <vs-button class="cancel-responsive" type="border" color="danger" @click="popupUpdateActive=false">Cancel</vs-button>
              </div>
            </div>
          </vs-popup>
          <vs-popup class="holamundo delete-group delete-popup" title="Restore Default Template" :active.sync="popupSetDefault">
              <div class="text-center">
                  <h3>Do you want to restore default for this template?</h3>
                  <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center delete-responsive" @click="setDefaultTemplate">Ok</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupSetDefault = false">Cancel</vs-button>
                  </div>
              </div>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'vs-ticket-setting',
  data(){
    return{
      popupAddActive: false,
      popupUpdateActive: false,
      customerText: [],
      options: [],
      select: {subject:'business_name', name: 'Business Name'},
      content: '',
      selected: {},
      param: '',
      key_selected: 0,
      ticket_id: '',
      action_type: '',
      isOpenLoading: false,
      loaded_data_num: 0,
      popupDeleteActive: false,
      popupSetDefault: false
    }
  },
  components: {
    'v-select': vSelect,
  },
  computed:{
    ticketList(){
      return this.$store.getters["appSetting/ticketList"];
    },
    blockList(){
      return this.$store.getters["appSetting/blockList"];
    }
  },
  watch:{
    popupAddActive:{
      immediate: true,
        deep: true,
        handler() {
          this.select = {subject:'business_name', name: 'Business Name'};
          this.content = '';
          if(this.popupAddActive) {
            document.body.classList.add('overflow-hidden');
          } else {
            document.body.classList.remove('overflow-hidden');
          }
        }
    },
    popupUpdateActive: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupUpdateActive) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    upTicket(ticket){
      const obj = {
        id: ticket.id,
        action: 'up'
      }
      this.action_type = 'Move';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/MOVE_SUBJECT" , obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      })
    },
    downTicket(ticket){
      const obj = {
        id: ticket.id,
        action: 'down'
      }
      this.action_type = 'Move';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/MOVE_SUBJECT" , obj).then(() => {
        this.closeLoading();
      }).catch(() => {
        this.closeLoading();
      })
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' ticket failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' ticket failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    addTicket(){
      const obj = {
        subject: this.select.subject,
        content: this.content
      }
      this.action_type = 'Add';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/CREATE_TICKET_TEMPLATE" , obj).then(() => {
        this.popupAddActive = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Add Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Fail',
          text:'Add Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    deleteTicket(ticket){
      const obj = {
        id: ticket.id
      }
      this.type_action = 'Delete';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/DELETE_TICKET_TEMPLATE" , obj).then(() => {
        this.closeLoading();
        this.popupDeleteActive = false;
        this.$vs.notify({
          title:'Success',
          text:'Delete Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.popupDeleteActive = false;
        this.$vs.notify({
          title:'Fail',
          text:'Delete Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    updateTicket(ticket){
      this.key_selected++;
      this.ticket_id = ticket.id;
      this.selected.subject =  ticket.subject;
      this.selected.name = ticket.name;
      this.popupUpdateActive = true;
      this.param = ticket.content
    },
    submitUpdate(){
      const obj = {
        id : this.ticket_id,
        subject: this.selected.subject,
        content: this.param
      }
      this.action_type = 'Update';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/UPDATE_TICKET_TEMPLATE", obj).then(() => {
        this.popupUpdateActive = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Update Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Fail',
          text:'Update Ticket Template Failed',
          color:'danger',
          position:'top-right'
        })
      })
    },
    changeFormText(){
      this.$store.dispatch("appSetting/GET_TICKET_LIST").then(() => {
        this.loaded_data_num++;
        let ticketList = this.$store.getters["appSetting/ticketList"];
        for(let i = 0; i< ticketList.length ; i++){
          if(ticketList[i].subject == 'custom_text'){
            this.customerText.push(ticketList[i])
          }
        }
      })
    },
    setDefaultTemplate() {
      let data = { type: 'receipt' };
      this.action_type = 'Set default';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("appSetting/SET_DEFAULT_TICKET_TEMPLATE", data).then(() => {
        this.popupSetDefault = false;
        this.closeLoading();
        this.$vs.notify({
          title:'Success',
          text:'Set Default Ticket Template Success',
          color:'success',
          position:'top-right'
        })
      }).catch((err) => {
        console.log('Error: ' + err);
      })
    }
  },
  created(){
    this.changeFormText();
    this.$store.dispatch("appSetting/GET_BLOCK_LIST").then(() => {
      this.loaded_data_num++;
      let blockList = this.$store.getters["appSetting/blockList"];
      for(let i = 0; i< blockList.length ; i++){
        this.options.push(blockList[i])
      }
    });
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
.vs__dropdown-menu{
  height: 150px;
}

#ticket-setting {
  .text-title {
    color: #626262;
  }

  .trash-icon {
    width: 15px;
    height: 18.89px; 
  }
}

// .delete-popup {
//   .delete-responsive, .cancel-responsive {
//     min-width: 140px !important;
//   }
//   @media (max-width: 405px) {
//     .delete-responsive {
//       margin: 0 0 15px !important;
//       width: 100%;
//     }
//     .cancel-responsive {
//       width: 100%;
//     }
//   }
// }

.update-ticket-popup, .create-block-ticket-popup {
  .save-responsive, .cancel-responsive {
    width: 140px;
  }

  label {
    font-size: 14px;
    display: inline-block;
    margin-top: 15px;
    margin-bottom: 5px;
  }

  @media (max-width: 405px) {
    .save-responsive {
      margin: 0 0 15px !important;
      width: 100%;
    }
    .cancel-responsive {
      width: 100%;
    }
  }
}

</style>
